import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { ReactComponent as CheckIcon } from '../../../../layout/icons/check.svg';
import { Typography } from '../../../../layout/components/Typography';
import { ColorScheme } from '../../../../layout/colorScheme';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const Icon = styled(CheckIcon)`
  display: block;
  flex-shrink: 0;
`;

interface CheckmarkLabelProps {
  children: ReactNode;
}

const CheckmarkLabel: FC<CheckmarkLabelProps> = ({ children }) => (
  <Row>
    <Icon />
    <Typography
      variant="contentSmall"
      as="span"
      align="left"
      color={ColorScheme.Grey7}
      style={{ minWidth: 0 }}
    >
      {children}
    </Typography>
  </Row>
);

export default CheckmarkLabel;
